import { Component, OnInit } from '@angular/core';
import { ApiResponse } from '../../models/api-response';
import { NotificationService } from "../../services/notification.service";
import { SystemServicesManager } from './system-service.service';
import { AppSettingsService } from "../../services/appsettings.service";

@Component({
    selector: 'system-service-management',
    template: require('./system-service.component.html')
})
export class SystemSeviceManagementComponent implements OnInit{
    systemType: string;
    invalidSystemType = false;
    responseData: any;
    resultMessage: string;
    systemServiceIdCollection: string[];
    systemServiceId:string;
    retrievedSystemTypes: string[];
    errorInFetchingSystemServices: boolean = true;
    isFetchSuccess:boolean = false;

    constructor(
        private notifier: NotificationService,
        private systemService: SystemServicesManager,
        private appSettingsService: AppSettingsService,) {
        this.notifier.clear();
    }

    ngOnInit(): void {
        this.getSystemServices();
    }

    getSystemServices() {
        this.notifier.displayInfo("Fetching System Services ...");
        this.appSettingsService.getSystemServices()
            .subscribe(
                resp => {
                    this.notifier.clear();
                    this.responseData = resp;
                    this.processSystemServiceResponse();
                },
                error => {
                    this.notifier.displayApiResponseError(error);
                    this.errorInFetchingSystemServices = true;
                }
            );
    }

    initializeCurrentTab() {
        this.notifier.clear();
        this.isFetchSuccess = false;
    }

    registerSystemService() {
        if (this.systemServiceId == null) {
            this.notifier.displayError("Please select a System Service");
            return;
        }
        this.notifier.displayInfo("Adding system service ...");
        this.systemService.registerSystemService(this.systemServiceId).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData.statusCode === 201) {
                    this.notifier.displaySuccess(this.responseData.data);

                } else {
                    this.notifier.displayError(this.responseData.data.value);
                }

            },
            error => {
                this.notifier.displayApiResponseError(error);

            });
    }

    deregisterSystemService() {
        this.notifier.displayInfo("Removing system service ...");
        if (this.systemServiceId == null) {
            this.notifier.displayError("Please select a System Service");
            return;
        }
        this.systemService.deregisterSystemService(this.systemServiceId).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData.statusCode === 200) {
                    this.notifier.displaySuccess(this.responseData.data);
                } else {
                    this.notifier.displayError(this.responseData.data.value);
                }

            },
            error => {
                this.notifier.displayApiResponseError(error);
            });
    }

    
    enableSystemService() {
        this.notifier.displayInfo("Enabling system service ...");
        if (this.systemServiceId == null) {
            this.notifier.displayError("Please select a System Service");
            return;
        }
        this.systemType = (this.systemType == null) ? this.systemType : this.systemType.trim();
        if (this.systemType == null || this.systemType === '') {

            this.invalidSystemType = true;
            this.notifier.displayError("Please enter a valid System Type");
            return;
        }
        this.invalidSystemType = false;
        this.systemService.enableSystemService(this.systemServiceId,this.systemType).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData.statusCode === 201) {
                    this.notifier.displaySuccess(this.responseData.data);

                } else {
                    this.notifier.displayError(this.responseData.data.value);
                }

            },
            error => {
                this.notifier.displayApiResponseError(error);

            });
    }

    disableSystemService() {
        this.notifier.displayInfo("Disabling system service ...");
        if (this.systemServiceId == null) {
            this.notifier.displayError("Please select a System Service");
            return;
        }
        this.systemType = (this.systemType == null) ? this.systemType : this.systemType.trim();
        if (this.systemType == null || this.systemType === '') {

            this.invalidSystemType = true;
            this.notifier.displayError("Please enter a valid System Type");
            return;
        }
        this.invalidSystemType = false;
        this.systemService.disableSystemService(this.systemServiceId, this.systemType).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData.statusCode === 200) {
                    this.notifier.displaySuccess(this.responseData.data);

                } else {
                    this.notifier.displayError(this.responseData.data.value);
                }

            },
            error => {
                this.notifier.displayApiResponseError(error);

            });
    }
    getSystemServiceStatus() {
        if (this.systemServiceId == null) {
            this.notifier.displayError("Please select a System Service");
            return;
        }
        this.systemType = (this.systemType == null) ? this.systemType : this.systemType.trim();
        if (this.systemType == null || this.systemType === '') {

            this.invalidSystemType = true;
            this.notifier.displayError("Please enter a valid System Type");
            return;
        }
        this.invalidSystemType = false;
        this.notifier.displayInfo("Fetching system service status...");
        this.systemService.getSystemServiceStatus(this.systemServiceId, this.systemType).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData.statusCode === 200) {
                    this.notifier.displaySuccess(this.responseData.data);

                } else {
                    this.notifier.displayError(this.responseData.data.value);
                }

            },
            error => {
                this.notifier.displayApiResponseError(error);

            });
    }

    getSystemTypes() {
        if (this.systemServiceId == null) {
            this.notifier.displayError("Please select a System Service");
            return;
        }
        this.notifier.displayInfo("Fetching system Types...");
        this.systemService.getSystemTypes(this.systemServiceId).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData.statusCode === 200) {
                    if (this.responseData.data.SystemTypes === null || this.responseData.data.SystemTypes.count === 0) {
                        this.notifier.displayError("No System Types are found for " + this.responseData.data.ServiceId);
                        this.isFetchSuccess = false;
                    } else {
                        this.notifier.displaySuccess("Successfully fetched System Types for " + this.responseData.data.ServiceId);
                        this.retrievedSystemTypes = this.responseData.data.SystemTypes;
                        this.isFetchSuccess = true;
                    }
                } else {
                    this.notifier.displayError(this.responseData.data.value);
                    this.isFetchSuccess = false;
                }

            },
            error => {
                this.notifier.displayApiResponseError(error);
                this.isFetchSuccess = false;
            });
    }
     processSystemServiceResponse() {
        console.log(this.responseData);
        if (this.responseData.status === 200) {
            this.systemServiceIdCollection = JSON.parse(this.responseData._body);
            if (this.systemServiceIdCollection.length === 0) {
                this.errorInFetchingSystemServices = true;
                this.notifier.displayError("No System services found");
            } else {
                this.errorInFetchingSystemServices = false;
                this.systemServiceId = this.systemServiceIdCollection[0];
            }
        } else {
            this.errorInFetchingSystemServices = true;
            this.notifier.displayError("Unable to fetch System services");
        }
    }
    
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/SystemServicesManager/system-service.component.ts
 **/